export const VALID_MATERIALNAME_REGEX = /^[\s\S]*[a-zA-Z][\s\S]*$/;
